// 调账

import { HttpAdjustAccountList } from '@/service/costbilling';
import TableList from "@components/templates/tablelist";
import compUpdate from './update'
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpAdjustAccountList,
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'add':
                    this.operate = {
                        title: '添加调账',
                        show: true,
                        width: 'middle',
                        component: "compUpdate",
                        showFooter: false,
                    }
                    break;
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/costAdjustment/export", this.formData,
                        { executor: 'request', download: true }
                    );
                    break;
                case "upload":
                    this.operate = {
                        show: true,
                        title: '导入数据',
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/costAdjustment/upload",
                        name: "file",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/costAdjustment/downloadTemplate", {}, {
                                executor: 'download',
                                type: 'url',
                                method: 'post',
                            });
                        }
                    };
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "导出",
                    operate: "export",
                    theme: "info",
                },
                {
                    name: "导入",
                    operate: "upload",
                    theme: "success",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "组织",
                    key: 'EQ_organizationId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                // {
                //     label: "仓库",
                //     key: 'EQ_warehouseId',
                //     show: true,
                //     tag: 'vSelect',
                //     options: this.getBillcusWareList,
                //     props: {
                //         filterable: true,
                //     },
                // },
                {
                    label: "账单编号",
                    key: 'EQ_billNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "月份",
                    key: 'EQ_month',
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm',
                        confirm: false,
                    },
                },
                {
                    label: "调账类型",
                    key: 'EQ_type',
                    tag: 'vSelect',
                    options: this.getAdjutmentType,
                    show: true,
                },
                {
                    label: "费用类型",
                    key: 'EQ_billingType',
                    tag: 'vSelect',
                    options: this.getCostType,
                },
            ]
        },
        columns() {
            return [
                {
                    title: '账单编号',
                    key: 'billNo',
                },
                {
                    title: '组织',
                    key: 'organizationName',
                },
                // {
                //     title: '仓库',
                //     key: 'warehouseCode',
                // },
                {
                    title: '月份',
                    key: 'month',
                },
                {
                    title: '费用类型',
                    key: 'billingType',
                    render: (h, { row }) => this.findRenderLabel(this.getCostType, row.billingType)
                },
                {
                    title: '计费单号',
                    key: 'billingOrderNo',
                },
                {
                    title: '调账类型',
                    key: 'type',
                    render: (h, { row }) => this.findRenderLabel(this.getAdjutmentType, row.type)
                },
                {
                    title: '调账金额',
                    key: 'amount',
                },
                {
                    title: '币种',
                    key: 'currency',
                },
                {
                    title: '调账说明',
                    key: 'remark',
                },
                {
                    title: '创建人',
                    key: 'createdName',
                },
                {
                    title: '更新时间',
                    key: 'updatedAt',
                }];
        },
    },
};




